export const dataHooks = {
  item: 'atlas-address-input-item',
};
